import React from 'react'
import PropTypes from 'prop-types'
import AddDomainResourceButton from './AddDomainResourceButton'

/**
 * A react component that controls when to display the Add Domain functionality
 */
const AddDomainResourceControl = (props) => (
	props.visible
		?
		<div className="AddDomainResourceControl">
			{React.Children.map(props.children, (child) => React.cloneElement(child, {click: props.click}))}
		</div>
		:
		null
)


AddDomainResourceControl.propTypes = {
	visible: PropTypes.bool.isRequired,
	click: PropTypes.func.isRequired,
	children: PropTypes.element.isRequired
}

AddDomainResourceControl.defaultProps = {
	children: <AddDomainResourceButton text='Add Domain Resource'/>
}

export default AddDomainResourceControl


// WEBPACK FOOTER //
// ./src/components/AddDomainResourceControl/AddDomainResourceControl.js